import { IFeature } from '@kurtosys/types/app/IFeature.js';

export const Feature: IFeature = {
	useResponsiveComponentConfiguration: true,
	useIntersectionObserver: true,
};
